import axios from 'axios'

export default axios.create({
	baseURL: process.env.NODE_ENV === 'production' ? 'https://api.studeerstipt.nl' : 'http://localhost:8080/'
})
